// extracted by mini-css-extract-plugin
module.exports = {"root":"rounded-button_root__NKN1a"};